import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { FiActivity, FiChevronRight } from 'react-icons/fi';
import { db } from '../../lib/firebase';
import { formatDate } from '../../lib/format';
import { Notice, Panel, Pill, SkeletonRows } from '../ui/kit';
import { examDate, valueOf } from './echoModel';

// Echocardiography reports attached to this patient file.
const PatientEchos = ({ patient }) => {
  const [state, setState] = useState({ status: 'loading', items: [] });

  useEffect(() => {
    let cancelled = false;
    getDocs(query(collection(db, 'echos'), where('patientId', '==', patient._id)))
      .then((snapshot) => {
        const items = snapshot.docs
          .map((item) => ({ id: item.id, ...item.data() }))
          .sort((a, b) => new Date(examDate(b) || 0) - new Date(examDate(a) || 0));
        if (!cancelled) setState({ status: 'ready', items });
      })
      .catch(() => !cancelled && setState({ status: 'error', items: [] }));
    return () => {
      cancelled = true;
    };
  }, [patient._id]);

  return (
    <Panel
      title="Échographies"
      action={
        <Link to="/echo" className="inline-flex items-center gap-1 text-[13px] font-medium text-brand-600 no-underline transition hover:text-brand-700 print:hidden">
          Section Échos <FiChevronRight size={13} aria-hidden="true" />
        </Link>
      }
    >
      {state.status === 'loading' ? (
        <SkeletonRows rows={1} />
      ) : state.status === 'error' ? (
        <Notice tone="amber">Échographies indisponibles pour le moment.</Notice>
      ) : state.items.length === 0 ? (
        <p className="m-0 text-[13.5px] text-black/45">Aucune échographie rattachée à ce patient.</p>
      ) : (
        <ul className="m-0 flex list-none flex-col gap-[10px] p-0">
          {state.items.map((echo) => {
            const fe = valueOf(echo, 'mensuration', 'fractionEjection');
            const resume = valueOf(echo, 'conclusion', 'resume');
            return (
              <li key={echo.id}>
                <Link to={`/echo/${echo.id}`} className="flex gap-[12px] rounded-2xl bg-mist px-[14px] py-[12px] text-ink no-underline transition hover:bg-black/[0.05] hover:text-ink">
                  <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-white text-rose-500">
                    <FiActivity size={15} aria-hidden="true" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center justify-between gap-2">
                      <span className="text-[14px] font-semibold">{formatDate(examDate(echo)) || 'Date non précisée'}</span>
                      {fe && <Pill tone="brand">FE {fe} %</Pill>}
                    </span>
                    {resume && <span className="mt-1 line-clamp-2 block text-[13px] leading-snug text-black/55">{resume}</span>}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </Panel>
  );
};

export default PatientEchos;
